<template>
  <div style="margin-top:30px">
    <el-form
      ref="form"
      :rules="rules"
      :model="form"
      label-width="80px"
    >
      <el-form-item
        label="标题"
        prop="title"
        style="margin-right:15px"
      >
        <el-input
          v-model.trim="form.title"
          placeholder="请输入公告标题"
          @change="(value)=>{form.title = value.replace(/\s/g,'')}"
        />
      </el-form-item>
      <el-form-item
        label="副标题"
        prop="subhead"
        style="margin-right:15px"
      >
        <el-input
          v-model.trim="form.subhead"
          type="textarea"
          :rows="3"
          placeholder="请输入公告副标题"
          @change="(value)=>{form.subhead = value.replace(/\s/g,'')}"
        />
      </el-form-item>
      <el-form-item
        label="编辑者"
        prop="editName"
        style="margin-right:15px"
      >
        <el-input
          v-model.trim="form.editName"
          placeholder="请输入公告编辑者"
          @change="(value)=>{form.editName = value.replace(/\s/g,'')}"
        />
      </el-form-item>
      <!-- <el-form-item
          label="类别"
          prop="newsType"
          style="margin-right:15px"
        >
          <el-select
            v-model="form.newsType"
            clearable
            placeholder="请选择"
          >
            <el-option
              value
              label="请选择"
            />
            <el-option
              v-for="(v,k) in dicts.newsType"
              :key="k"
              :label="v"
              :value="k"
            />
          </el-select>
        </el-form-item> -->
      <el-form-item
        label="图片"
        style="margin-right:15px"
        
      >
        <ImgUpload
          :upload-config="{ lebal: '公告图片', prefix: 'img', form, suffix: 'Url', modal: false }"
          :parent-data="{ isDetail: false }"
          :required= "false"
        />
      </el-form-item>
      <el-form-item
        label="公告内容"
        prop="content"
        style="margin-right:15px"
      >
        <myEditor
          v-model="form.content"
          :disabled="false"
        />
      </el-form-item>
    </el-form>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="funcCancel">
        取 消
      </el-button>
      <el-button
        type="primary"
        @click="funcSubmit"
      >
        确 定
      </el-button>
    </div>
  </div>
</template>
  <script>
  import ImgUpload from "@/components/ImgUpload";
  import request from "@/utils/request";
  import myEditor from "@/components/MyEditor";
  
  export default {
    name: "BulletinAdd",
    components: {
      myEditor,
      ImgUpload
    },
    props: {
      dicts: {
        type: Object,
        default(){
          return { isRelease: {}, newsType: {} }
        }
      }
    },
    data() {
      return {
        form: {
          imgUrl: "",
          title: "",
          subhead: "",
          content: "",
          editName: "",
          newsType: "0",
          ifRelease: "0"
        },
        rules: {
          title: [
            { required: true, message: "请输入标题", trigger: "blur" },
            {
              min: 1,
              max: 255,
              message: "长度在 1 到 255 个字符",
              trigger: "blur"
            }
          ],
          subhead: [
            { required: true, message: "请输入副标题", trigger: "blur" },
            {
              min: 1,
              max: 1000,
              message: "长度在 1 到 1000 个字符",
              trigger: "blur"
            }
          ],
          content: [
            { required: true, message: "请输入内容", trigger: "blur" },
            {
              min: 1,
              max: 16777215,
              message: "长度在 1 到 16777215 个字符",
              trigger: "blur"
            }
          ],
          editName: [
            { required: true, message: "请输入编辑者", trigger: "blur" },
            {
              min: 1,
              max: 255,
              message: "长度在 1 到 255 个字符",
              trigger: "blur"
            }
          ],
        //   newsType: [
        //     { required: true, message: "请选择类别", trigger: "blur" }
        //     ]
        }
      };
    },
    created() {
      this.init();
    },
    methods: {
      // 提交
      funcSubmit() {
        this.$refs["form"].validate(valid => {
          if (valid) {
            const rLoading = this.openLoading();
            const data = this.form;
            request({ url: "/ntocc-basic-api/bulletin", method: "post", data })
              .then(response => {
                rLoading.close();
                this.$message({ message: response.msg, type: "success" });
                this.$emit("fatherAddMethod");
              })
              .then(() => this.$refs["form"].resetFields());
          } else {
            return false;
          }
        });
      },
      // 取消
      funcCancel() {
        this.$emit("fatherCancelMethod", "add");
      },
      init() {
        this.form = {
          imgUrl: "",
          title: "",
          subhead: "",
          content: "",
          editName: "",
          newsType: "0",
          ifRelease: "0"
        };
        this.$nextTick(function(){
          this.$refs["form"].resetFields()
        })
      }
    }
  };
  </script>
  <style lang="scss" scoped>
  .dialog-footer {
    margin: 15px 0 15px 0;
    width: 175px;
    float: right;
  }
  </style>
  